export default "__VITE_ASSET__DWoyaoZp__"